import httpClient from "@/services/http.service"

const securityEventsService = {
  getEventsForSecurity() {
    return httpClient.get(`/events/events/get-events-for-security`)
  }
}

export default securityEventsService